<template>
  <div>
    <ul style="padding: 1em">
      <li v-for="item in data" :key="item._id" style="margin-bottom: 1rem">
        <fob-entity-compact-cyan
          :data="item"
          :entityDetailsRoute="entityDetailsRoute"
          :entityEditRoute="entityEditRoute"
          :show-publications-count="showPublicationsCount"
          :show-publication-type="showPublicationType"
          :show-star="showStar"
        >
        </fob-entity-compact-cyan>
      </li>
    </ul>
    <b-loading :is-full-page="false" :active.sync="loading"></b-loading>
  </div>
</template>

<script>
import EntityCompactCyan from '@/components/EntityCompactCyan'

export default {
  name: 'fob-entity-list-compact-cyan',
  props: [
    'data',
    'entityDetailsRoute',
    'entityEditRoute',
    'showPublicationsCount',
    'showPublicationType',
    'showStar',
    'loading'
  ],
  components: {
    'fob-entity-compact-cyan': EntityCompactCyan
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/EntityListCompactCyan.vue